import { Icon } from "icons";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "ui";

import { type InsertButtonProps } from "src/workouts/LinkUnlinkWorkoutItemsButton";
import { SectionFormatIcon } from "src/workouts/SectionFormatIcon";

export const InsertButton = observer(function InsertButton(
  props: InsertButtonProps,
) {
  const { t } = useTranslation();
  const showSectionSubmenu = props.sections.length > 0;

  if (!showSectionSubmenu) {
    return (
      <Button
        variant="outline"
        size="icon-sm"
        onClick={props.onInsert}
        title="Insert exercise"
      >
        <Icon name="tabler-plus" />
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon-sm" title="Insert item">
          <Icon name="tabler-plus" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent alignOffset={300} className="min-w-[180px]">
        <DropdownMenuItem onClick={props.onInsert}>
          {t("editWorkout.addExercise")}
        </DropdownMenuItem>
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            {t("editWorkout.addSectionButton")}
          </DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent className="min-w-[160px]">
              {props.onImportFromLibrary && (
                <>
                  <DropdownMenuItem
                    onClick={props.onImportFromLibrary}
                    className="gap-2"
                  >
                    <Icon name="tabler-section" size={16} />
                    {t("editWorkout.importSection.fromLibrary")}
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                </>
              )}
              {props.sections.map((section) => {
                return (
                  <DropdownMenuItem
                    key={section.format}
                    onClick={() => {
                      props.onAddSection(section.format);
                    }}
                    className="gap-2"
                  >
                    <SectionFormatIcon format={section.format} />
                    {t(section.labelKey)}
                  </DropdownMenuItem>
                );
              })}
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
      </DropdownMenuContent>
    </DropdownMenu>
  );
});
